import React from 'react';

/**
 * NotFound component displays a simple "Not found - 404" message when the requested page is not found.
 * @returns {JSX.Element} The NotFound component JSX
 */
const NotFound = (): JSX.Element => {
  return (
    <div className="w-full pt-[10%] pb-[10%] h-screen text-white flex flex-col items-center justify-center">
      <h1 className="text-[140px] font-bold uppercase text-center animate-opacity mb-0 sm:text-[60px] smTablet:text-[80px]">
        404
      </h1>
      <p className="mt-0 font-bold text-[60px] text-center sm:text-[26px] smTablet:text-[32px]">
        Page Missing in Action!
      </p>
    </div>
  );
};

export default NotFound;
